module.exports = __webpack_public_path__ + "img/ico-social_media.5bf62898.svg";